<script lang="ts">
  import { Router, Route, Link } from "svelte-routing";
  import Home from "./routes/Home.svelte";
  import NotFound from "./routes/NotFound.svelte";
  import Pandemieradar from "./routes/projects/pandemieradar/+page.svelte";
  import MadeToMeasure from "./routes/projects/made-to-measure/+page.svelte";
  import FactSnap from "./routes/projects/fact-snap/+page.svelte";
  import Soli from "./routes/projects/project-soli/+page.svelte";
  import DBPeakSpotting from "./routes/projects/db-peak-spotting/+page.svelte";
  import AOKDesignSystem from "./routes/projects/aok-design-system/+page.svelte";
  import Blanq from "./routes/projects/blanq/+page.svelte";
  import DoYouLikeWorking from "./routes/projects/do-you-like-working/+page.svelte";
  import SelfDrivingCar from "./routes/projects/self-driving-car/+page.svelte";
  import IsThisThingOn from "./routes/projects/is-this-thing-on/+page.svelte";
  import FramingArtScienceTechnology from "./routes/projects/framing-art-science-technology/+page.svelte";
  import KnownUnknowns from "./routes/projects/known-unknowns/+page.svelte";
  import GestaltDigitalIdentity from "./routes/projects/gestalt-digital-identity/+page.svelte";
  import DesignForDecisions from "./routes/projects/design-for-decisions/+page.svelte";
  import Imprint from "./routes/imprint/+page.svelte";
  import PrivacyPolicy from "./routes/privacy-policy/+page.svelte";
  import Nav from "$lib/components/Nav.svelte";

  // Set the base URL to empty string for development
  export let url = "";
</script>

<!-- Make sure the Router is at the root level -->
<Router {url}>
  <Nav />
  <main class="pt-20">
    <Route path="/" component={Home} />
    <Route path="/projects/pandemieradar" component={Pandemieradar} />
    <Route path="/projects/made-to-measure" component={MadeToMeasure} />
    <Route path="/projects/fact-snap" component={FactSnap} />
    <Route path="/projects/project-soli" component={Soli} />
    <Route path="/projects/db-peak-spotting" component={DBPeakSpotting} />
    <Route path="/projects/aok-design-system" component={AOKDesignSystem} />
    <Route path="/projects/blanq" component={Blanq} />
    <Route path="/projects/do-you-like-working" component={DoYouLikeWorking} />
    <Route path="/projects/self-driving-car" component={SelfDrivingCar} />
    <Route path="/projects/is-this-thing-on" component={IsThisThingOn} />
    <Route path="/projects/known-unknowns" component={KnownUnknowns} />
    <Route path="/projects/gestalt-digital-identity" component={GestaltDigitalIdentity} />
    <Route path="/projects/framing-art-science-technology" component={FramingArtScienceTechnology} />
    <Route path="/projects/design-for-decisions" component={DesignForDecisions} />
    <Route path="/imprint" component={Imprint} />
    <Route path="/privacy-policy" component={PrivacyPolicy} />
    <Route path="*" component={NotFound} />
  </main>
</Router>